export default __webpack_public_path__ + "f0e75a611ca98fedc5dbf084a647c2f2.png";